<form [formGroup]="mainForm">
    <h1>{{ organizationDetails.OrganizationName }}</h1>
  <div class="p-grid p-fluid">
    <div class="col-md-6 col-sm-12 col-xs-12">
      <label>Password<span class="req"> *</span></label>
      <input [type]="passwordType" class="p-mb-2" pInputText formControlName="password">
      @if (mainForm.controls.password.invalid && mainForm.controls.password.dirty) {
        <div class="p-error">
          @if (mainForm.controls.password.errors?.required) {
            <div>New Password is required</div>
          }
          <!--                <div *ngIf="changePasswordForm.controls.password.errors?.pattern">Must contain at least one uppercase and lowercase letter, one number, one special character, and be at least 10 characters long</div>-->
          @if (mainForm.controls.password.hasError('length')) {
            <div>Must be at least 10 characters long</div>
          }
          @if (mainForm.controls.password.hasError('uppercase')) {
            <div>Must contain at least one uppercase letter (A-Z)</div>
          }
          @if (mainForm.controls.password.hasError('lowercase')) {
            <div>Must contain at least one lowercase letter (a-z)</div>
          }
          @if (mainForm.controls.password.hasError('number')) {
            <div>Must contain at least one number (0-9)</div>
          }
          @if (mainForm.controls.password.hasError('special')) {
            <div [innerHTML]="'Must contain at least one special character ($@#!%*?&)'"></div>
          }
          @if (mainForm.controls.password.hasError('repeats')) {
            <div>Must have no more than 2 identical characters in a row (999 not allowed)</div>
          }
          @if (mainForm.controls.password.hasError('customValidator')) {
            <div>No parts of your username</div>
          }
        </div>
      }
      <div class="checkbox-container p-pt-0">
      <p-checkbox class="p-mb-2" [binary]="true" formControlName="showPassword"></p-checkbox>
        <label class="add-display-inline force-auto-width">Show Password</label>
      </div>
    </div>
    <div class="col-md-6 col-sm-12 col-xs-12">
      <label>Confirm Password<span class="req"> *</span></label>
      <input [type]="passwordConfirmType" class="p-mb-2" pInputText formControlName="passwordConfirm">
      @if (mainForm.controls.passwordConfirm.invalid && mainForm.controls.passwordConfirm.dirty) {
        <div class="p-error">
          @if (mainForm.controls.passwordConfirm.errors?.required) {
            <div>Confirm New Password is required</div>
          }
          @if (mainForm.controls.passwordConfirm.errors?.confirmedValidator) {
            <div>New Password & Confirm New Password do not match</div>
          }
        </div>
      }
      <div class="checkbox-container p-pt-0">
        <p-checkbox class="p-mb-2" [binary]="true" formControlName="showPasswordConfirm"
                    ></p-checkbox>
        <label class="add-display-inline force-auto-width">Show Password</label>
      </div>
    </div>


    <p>Please take a moment to select and provide answers to three security questions. Doing so will help you
      reset your password in the future. Many thanks!</p>
      <div class="col-md-12 col-sm-12 col-xs-12 p-mt-2">

          <app-select class="full-width" [inputObj]="inputObjQuestion1"
                      (emitData)="getQuestion1Data($event)"></app-select>

      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 p-mt-2">
        <label>Answer<sup class="req">*</sup></label>
        <input pInputText formControlName="answer1" maxlength="100">
        @if (mainForm.controls.answer1.invalid && mainForm.controls.answer1.dirty) {
          <div class="p-error">
            @if (mainForm.controls.answer1.errors?.required) {
              <div>An answer is required</div>
            }
            @if (mainForm.controls.answer1.errors?.minlength) {
              <div>Answer must be between 4 and 100 characters</div>
            }
          </div>
        }
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 p-mt-4">
          <app-select class="full-width" [inputObj]="inputObjQuestion2"
                      (emitData)="getQuestion2Data($event)"></app-select>

      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 p-mt-2">
        <label>Answer<sup class="req">*</sup></label>
        <input pInputText formControlName="answer2" maxlength="100">
        @if (mainForm.controls.answer2.invalid && mainForm.controls.answer2.dirty) {
          <div class="p-error">
            @if (mainForm.controls.answer2.errors?.required) {
              <div>An answer is required</div>
            }
            @if (mainForm.controls.answer2.errors?.minlength) {
              <div>Answer must be between 4 and 100 characters</div>
            }
          </div>
        }
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 p-mt-4">

          <app-select class="full-width" [inputObj]="inputObjQuestion3"
                      (emitData)="getQuestion3Data($event)"></app-select>

      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 p-mt-2">
        <label>Answer<sup class="req">*</sup></label>
        <input pInputText formControlName="answer3" maxlength="100">
        @if (mainForm.controls.answer3.invalid && mainForm.controls.answer3.dirty) {
          <div class="p-error">
            @if (mainForm.controls.answer3.errors?.required) {
              <div>An answer is required</div>
            }
            @if (mainForm.controls.answer3.errors?.minlength) {
              <div>Answer must be between 4 and 100 characters</div>
            }
          </div>
        }
      </div>



      <div class="next-page-button">
        <p-button label="Next" (click)="goToNextPage()" [disabled]="mainForm.invalid"/>
      </div>
    </div>
</form>
